import Vue from 'vue'
import 'vant/lib/index.css'
// By default we import all the components.
// Only reserve the components on demand and remove the rest.
// Style is always required.
import {
  Uploader,
  DatetimePicker,
  Popup,
  Dialog,
  Cascader,
  Picker,
  Search,
  Overlay,
  Button,
  Tag,
  Icon,
  Progress,
  Empty,
  Loading,
  Field
} from 'vant'

Vue.use(Uploader)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Cascader)
Vue.use(Picker)
Vue.use(Search)
Vue.use(Overlay)
Vue.use(Button)
Vue.use(Tag)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Empty)
Vue.use(Loading)
Vue.use(Field)
